import { render } from "./GetItems.vue?vue&type=template&id=160dbff8&scoped=true"
import script from "./GetItems.vue?vue&type=script&lang=js"
export * from "./GetItems.vue?vue&type=script&lang=js"

import "./GetItems.vue?vue&type=style&index=0&id=160dbff8&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160dbff8"]])

export default __exports__